import { FormattedMessage } from 'react-intl';
import { InvitedTeamMemberStatusModel } from '../../../types/signup/common';
import {
  FailureCount,
  InvitationStatusHeader,
  InvitationStatusHeaderText,
  InviteUserEmailAndRoleItem,
  InviteUserFailureResposeStatus,
  InviteUserItem,
  InviteUserResponseDetails,
  InviteUserResponseEmail,
  InviteUserResponseRole,
  InviteUserResposeStatus,
  InviteUserSuccessResposeStatus,
  InviteUsersList,
  SuccessCount,
} from '../styles/Common';

export interface InviteStatusProps {
  invitationResponseStatus: InvitedTeamMemberStatusModel[];
}

export function InviteStatus({ invitationResponseStatus }: InviteStatusProps) {
  const capitalizeString = (str: string) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const statusCount = invitationResponseStatus.reduce(
    (acc, item) => {
      if (item.status === 200) {
        acc.success += 1;
      } else {
        acc.failure += 1;
      }
      return acc;
    },
    { success: 0, failure: 0 },
  );

  return (
    <InviteUsersList>
      <InvitationStatusHeader>
        <SuccessCount>({statusCount.success})</SuccessCount>
        <InvitationStatusHeaderText>
          <FormattedMessage id='myProfile.manageTeam.modal.newMembersInvited' />
        </InvitationStatusHeaderText>
        <FailureCount>({statusCount.failure})</FailureCount>
        <InvitationStatusHeaderText>
          <FormattedMessage id='myProfile.manageTeam.modal.membersInviteFailed' />
        </InvitationStatusHeaderText>
      </InvitationStatusHeader>
      {invitationResponseStatus.map((invite, index) => {
        return (
          <InviteUserItem key={index}>
            <InviteUserResponseDetails>
              <InviteUserEmailAndRoleItem>
                <InviteUserResponseEmail>{invite.email}</InviteUserResponseEmail>
                <InviteUserResponseRole>{capitalizeString(invite.role)}</InviteUserResponseRole>
              </InviteUserEmailAndRoleItem>
              <InviteUserResposeStatus>
                {invite.status == 200 ? (
                  <InviteUserSuccessResposeStatus>
                    <FormattedMessage id='myProfile.manageTeam.modal.inviteSuccess' />
                  </InviteUserSuccessResposeStatus>
                ) : (
                  <InviteUserFailureResposeStatus>
                    <FormattedMessage id='myProfile.manageTeam.modal.inviteFailed' />
                  </InviteUserFailureResposeStatus>
                )}
              </InviteUserResposeStatus>
            </InviteUserResponseDetails>
          </InviteUserItem>
        );
      })}
    </InviteUsersList>
  );
}
